import type { EnrichedContactMetier } from "models";

export type SearchTableSortableColumnKey =
  | "commune"
  | "metier"
  | "perimetre"
  | "poste"
  | "territoire";

export type SearchSortFunction = (cm1: EnrichedContactMetier, cm2: EnrichedContactMetier) => number;

export interface TableColumnHead {
  id: SearchTableSortableColumnKey;
  libelle: string;
  sortFunction: SearchSortFunction;
}

export enum SortingOrder {
  ASC = "asc",
  DESC = "desc",
}
